<template>
  <div class="games" v-if="games.length > 0">
    <div class="team" v-for="image in games" :key="image.value.path">
      <img :src="`${$store.state.ASSET_URL}${correctTBD($store, image)}`" alt="" />      
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  games: Array,
  needsBlue:Boolean
});
function correctTBD($store, image) {
  if(props.needsBlue && image.value.path === '/admin/storage/uploads/2022/12/29/nfc-west-tbd_uid_63adc74f09564.svg') {
    return '/admin/storage/uploads/2023/04/11/nfc-west-tbd-blue_uid_6435e6f908f0a.svg';
  }
  return image.value.path;
}
</script>

<style lang="scss" scoped>
.team {
  width: 32px;
  height: 32px;  
  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
}
.games {
  padding: 0;
  padding-right: 0;
  display: flex;
  flex-wrap: wrap;
  row-gap: 5px;
  column-gap: 15px;
  justify-content: center;
  flex-grow: 1;
  max-width: 250px;
}
</style>